<template>
  <page-layout>
    <template #header-title>
      <back-link href="/">
        {{ $trlMessage('header.applicants_and_vacancies') }}
      </back-link>
    </template>
    <template #content>
      <div :class="$style.wrapper">
        <h1 :class="$style.caption">{{ $trlMessage('page.settings.title') }}</h1>

        <tab-group :tab="$route.name">
          <template #tabs>
            <router-link v-for="page in pages" :key="page.name" :to="page.to" custom>
              <template #default="{ href, navigate }">
                <base-tab :name="page.name" :href="href" @selected="navigate">
                  {{ page.text }}
                </base-tab>
              </template>
            </router-link>
          </template>
          <template #content>
            <router-view />
          </template>
        </tab-group>
      </div>
    </template>
  </page-layout>
</template>

<script>
import BaseTab from '@/components/tabs/base-tab';
import TabGroup from '@/components/tabs/tab-group';
import BackLink from '@/components/page-layout/back-link.vue';
import PageLayout from '@/components/page-layout/page-layout.vue';

export default {
  name: 'SettingsApp',
  components: { PageLayout, BackLink, BaseTab, TabGroup },
  props: {
    pages: {
      type: Array,
      required: true
    }
  }
};
</script>

<style module lang="less">
@import '~@less/common/mixins/font';

.wrapper {
  padding: 0 15px;
  max-width: 90%;
  position: relative;

  composes: col-xs-offset-2 col-xs-9 from global;
}
.caption {
  font-size: 22px;
  line-height: 30px;
  .font_bold();
  padding: 0;
  margin: 40px 0 30px;
}
</style>

<i18n lang="json">{}</i18n>
